import { render, staticRenderFns } from "./Courtesy.vue?vue&type=template&id=10b12c54&scoped=true&"
import script from "./Courtesy.vue?vue&type=script&lang=js&"
export * from "./Courtesy.vue?vue&type=script&lang=js&"
import style0 from "./Courtesy.vue?vue&type=style&index=0&id=10b12c54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b12c54",
  null
  
)

export default component.exports